var map = {
  "./cs.json": [
    "pQ",
    [
      "7qy"
    ]
  ],
  "./en.json": [
    "Moq",
    [
      "2z"
    ]
  ],
  "./pl.json": [
    "ybv",
    [
      "0t"
    ]
  ],
  "./ru.json": [
    "xj",
    [
      "jo"
    ]
  ],
  "./tr.json": [
    "CcH",
    [
      "8p"
    ]
  ],
  "./ja.json": [
    "o9h",
    [
      "ez"
    ]
  ],
  "./zh.json": [
    "U8q",
    [
      "y7"
    ]
  ],
  "./pt-br.json": [
    "Mt",
    [
      "m5"
    ]
  ],
  "./de.json": [
    "XD",
    [
      "1f6"
    ]
  ],
  "./es.json": [
    "Ih",
    [
      "qbd"
    ]
  ],
  "./fr.json": [
    "OD",
    [
      "c4"
    ]
  ],
  "./it.json": [
    "Nu",
    [
      "7q"
    ]
  ],
  "./ko.json": [
    "Rrz",
    [
      "fmw"
    ]
  ],
  "./pt.json": [
    "yJ",
    [
      "oj"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "TXM";
module.exports = __rspack_async_context;
